"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgSttOxigenoterapiaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 31,
    fill: "#0A6FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 40.775V23.559h9.966v17.216H20.32zM30.287 41.68v8.862c0 1.08-.495 1.559-1.602 1.559H21.88c-1.046 0-1.562-.498-1.562-1.507V41.68h9.968zM30.275 22.653h-9.903c0-1.413-.14-2.821.035-4.192.234-1.764 1.83-3.001 3.625-3.038 1.06-.016 2.137-.063 3.174.094.85.147 1.622.581 2.182 1.23.56.649.874 1.47.887 2.323.026 1.184 0 2.368 0 3.583z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.131 33.526a.843.843 0 01-.645-.282.993.993 0 01-.26-.7v-3.926c0-.278.086-.511.26-.7a.843.843 0 01.645-.282h2.266c.256 0 .472.094.645.282.174.189.26.422.26.7v3.926a.992.992 0 01-.26.7.843.843 0 01-.645.282H22.13zm.453-1.473h1.36V29.11h-1.36v2.944zM26.209 33.261v2.077h2.718v-1.133h-1.812v-.566h1.208a.531.531 0 00.43-.217.834.834 0 00.174-.538v-1.322a.834.834 0 00-.173-.538.531.531 0 00-.43-.217h-2.115v1.133h1.812v.566h-1.208a.53.53 0 00-.43.218.834.834 0 00-.174.538z",
    fill: "#0A6FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49 13.591c0-.5.406-.906.907-.906h1.359c.5 0 .906.406.906.906v.907h-3.171v-.906z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.132,
    y: 10.42,
    width: 5.89,
    height: 1.359,
    rx: 0.453,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.38 13.592c1.418.023 2.93-.067 4.298.393 1.909.643 2.772 2.073 3.02 4.045.361 2.868.358 4.81-.52 8.772-1.169 5.285-1.96 7.483-1.169 10.512 1.001 3.831 5.564 6.41 9.45 3.82 3.497-2.332 2.768-6.432 2.814-10.052",
    stroke: "#fff",
    strokeWidth: 1.608,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.661 26.163l-6.01-7.187a.64.64 0 00-1.1.195c-2.766 8.163 2.533 9.489 6.681 8.466.659-.163.864-.954.429-1.474z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.323
  }));
}
var _default = exports["default"] = SvgSttOxigenoterapiaIcon;